import {pick} from 'lodash';
import {connect} from 'react-redux';
import OnTrack from '../components/on-track';
import {notOnTrack} from '../actions/on-track';

const mapStateToProps = (state) => pick(state, ['student', 'onTrack', 'bulkEntryCourses']);

const mapDispatchToProps = (dispatch) => ({
  notOnTrack() {
    dispatch(notOnTrack());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OnTrack);
